import {
  Col, Form, Input, Row, Switch, FormInstance,
} from 'antd';
import type { Dayjs } from 'dayjs';
import React from 'react';
import {
  GuaranteesInfo, PriceOverviewInfo, TariffTooltipsInfo,
} from '../../../../hooks/api/tariffs';
import PriceOverviewFields from './PriceOverviewFields';
import GuarantiesFields from './GuarantiesFields';
import GuarantiesTextFields from './GuarantiesFields/GuarantiesTextFields';
import GuarantiesAddMoreFields from './GuarantiesFields/GuarantiesAddMoreFields.tsx';

export interface TariffPeriodFormValues extends GuaranteesInfo {
  id?: string;
  startDate: Dayjs | string | null;
  endDate: Dayjs | string | null;
}

export interface TariffFormValues extends GuaranteesInfo {
  tariffId: number;
  name: string;
  isActive: boolean;
  isPriceOverviewVisible: boolean;
  brevoListId: number | null;
  invitationPageUrl: string | null;

  priceOverview: PriceOverviewInfo;
  tooltips: TariffTooltipsInfo;

  periods: TariffPeriodFormValues[];
}

export interface TariffFormProps {
  form?: FormInstance<TariffFormValues>; // 👈 новый проп
  initialValues?: TariffFormValues;
  onSubmit: (values: TariffFormValues) => void | Promise<void>;
  disabled?: boolean;
}

export function TariffForm({
  form: externalForm,
  initialValues,
  onSubmit,
  disabled,
}: TariffFormProps) {
  const [form] = Form.useForm<TariffFormValues>();

  // form.getFieldValue('');

  const handleFinish = async (values: TariffFormValues) => {
    try {
      await onSubmit(values);
    } finally {
      // setLoading(false);
    }
  };

  const currentForm = externalForm ?? form;

  return (
    <Form<TariffFormValues>
      form={currentForm}
      layout="vertical"
      initialValues={initialValues || {
        tariffId: 0,
        name: '',
        isActive: true,
        isPriceOverviewVisible: false,
        periods: [],
      }}
      onFinish={handleFinish}
      disabled={disabled}
    >
      <Form.Item
        label="Tariff ID"
        name="tariffId"
        rules={[{ required: true, message: 'Please enter a tariff ID' }]}
      >
        <Input type="number" placeholder="e.g., 101" />
      </Form.Item>

      <Form.Item
        label="Tariff Name"
        name="name"
        rules={[{ required: true, message: 'Please enter a tariff name' }]}
      >
        <Input placeholder="Please enter" />
      </Form.Item>

      <Row gutter={12}>
        <Col span={8}>
          <Form.Item label="Invite Friends active" name="isActive" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label="URL landing page"
            name="invitationPageUrl"
            tooltip={(
              <div>
                Should start with https:// and end with /.
                <br />
                E.g.
                {' '}
                <code>https://example.com/</code>
              </div>
            )}
            rules={[
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.resolve();
                  }

                  if (/\s/.test(value)) {
                    return Promise.reject(new Error('URL must not contain spaces'));
                  }

                  if (!/^https:\/\/.+\//.test(value)) {
                    return Promise.reject(
                      new Error('Must start with https:// and end with /'),
                    );
                  }

                  try {
                    // eslint-disable-next-line no-new
                    new URL(value);
                  } catch {
                    return Promise.reject(new Error('Please enter a valid URL'));
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="https://example.com/" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        label="Brevo List ID"
        name="brevoListId"
        // rules={[{ required: true, message: 'Please enter a Brevo List ID' }]}
      >
        <Input type="number" placeholder="e.g., 7" />
      </Form.Item>

      <GuarantiesFields />
      <GuarantiesAddMoreFields currentForm={currentForm} disabled={disabled} />
      <PriceOverviewFields />
      <GuarantiesTextFields />

    </Form>
  );
}
